require('moment');
#require('jqueryDateRangePickerJs');
#require('webpack-jquery-ui/selectmenu');
require("../app/form.coffee")
require('../app/news.coffee')
#require("../app/bulletin_filter.coffee")
require('../app/ajax_load_news_content.coffee')
require('../app/image_resizer.coffee')

window.newsPageInit = false

pageInit = ->
  window.newsPageInit = true
  window.NewsObject = new window.News()
  window.ajaxLoadNews = new window.AjaxLoadNewsContent()
  new window.Form()
  setTimeout( ->
    new window.ImageResizer()
  ,900)


$(document).ready ->
  if window.newsPageInit != true
    pageInit()
  window.newsPageInit = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/news.coffee